import { render } from "./DepositMethodsGridLesotho.vue?vue&type=template&id=7732109c&scoped=true"
import script from "./DepositMethodsGridLesotho.vue?vue&type=script&lang=js"
export * from "./DepositMethodsGridLesotho.vue?vue&type=script&lang=js"

import "./DepositMethodsGridLesotho.vue?vue&type=style&index=0&id=7732109c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7732109c"]])

export default __exports__